import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = [ "startDate", "startTime"
    ];

    connect()
    {
        let now = Date.now();
        setTimeout(() =>
        {
            this.startDateTarget._flatpickr.setDate(now);
            this.startTimeTarget._flatpickr.setDate(now);
        }, 300);
    }

    handleResponse(event)
    {
        if (event.detail[0].success)
		{
			const createEvent = new CustomEvent("show-toast", { detail: "Device successfully placed In Service!" });
			window.dispatchEvent(createEvent);

            setTimeout(() =>
            {
                this.element.previousElementSibling.querySelector(".goback").firstElementChild.click();
            }, 500);
		}
		else
		{
			const errorEvent = new CustomEvent("show-toast", { detail: "An error occurred: " + event.detail[0].error });
			window.dispatchEvent(errorEvent);
		}
    }

}